import React from 'react';
import PendingAuditionSlider from '../PendingAuditionSlider/PendingAuditionSlider';
import { useHistory } from "react-router-dom";
import AdminAuditionNav from '../AdminAuditionNav/AdminAuditionNav';

const PendingAudition = () => {

return (
<>
    <AdminAuditionNav />

    <div className="card card-bg head-line mt-4 mb-2 mt-4 mb-2">
        <div className="text-light d-flex p-2">
            <div className="faTrophy">
                <i className="fas fa-trophy"></i>
            </div>
            <h4 className="mx-3 text-white p-2">Pending Auditions</h4>
        </div>
    </div>

    <PendingAuditionSlider />
</>
);
};

export default PendingAudition;
